import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=4a99cbb2&"
import script from "./Withdrawal.vue?vue&type=script&lang=ts&"
export * from "./Withdrawal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports